import { useFormik } from "formik";
import { useEffect, useState } from "react";
import { Col, Form, Row, Button, Container, InputGroup, FormControl, Image, Badge } from "react-bootstrap";
import {
  getNew,
  updateNew,
  getImage,
  addTags,
  deleteTags
} from "../../services/api";
import LoadingIndicator from "../LoadingIndicator";
import SuccessAlert from "../SuccessAlert";
import ErrorAlert from "../ErrorAlert";
import { UpdateProductSchema } from "../../utils/validation_schemas";
import Select from 'react-select';
import useNotification from "../../contexts/notification";
import { UpdateProductData } from "../../utils/payloads";
import useCategories from "../../hooks/useCategories";
import useBadges from "../../hooks/useBadges";
import useTypes from "../../hooks/useTypes";
import { MdLink, MdAdd, MdRemoveCircle } from 'react-icons/md';
//import ReactQuill from 'react-quill';
//import 'react-quill/dist/quill.snow.css';
import { Editor } from '@tinymce/tinymce-react';
export default function UpdateProductForm({ productId, onSubmit }) {
  const tinymceScriptSrc = 'https://cdn.tiny.cloud/1/htwonga7qqiz96jdlavjriv28pllfct0g3qg18kbyml6xxos/tinymce/6/tinymce.min.js';

  const [isLoading, setIsLoading] = useState(true);
  const [status, setStatus] = useState("start");
  const categories = useCategories();
  const [promotionCategory, setPromotionCategory] = useState([]);
  const clearStatus = () => setStatus({ status: "start" });
  const [submitting, setSubmitting] = useState(false);
  const { setMessage } = useNotification();
  const [partners, setPartners] = useState([]);
  const [images, setImages] = useState([]);
  const [tagInput, setTagInput] = useState('');
  const [selectedImageId, setSelectedImageId] = useState('');
  const types = useTypes();
  const badges = useBadges();
  const [showModal, setShowModal] = useState(false);
  const [key, setKey] = useState('upload');
  const [selectedImage, setSelectedImage] = useState(null);
  const handleSelectTab = (k) => {
    setKey(k);
    if (k === 'gallery') {
      setShowModal(true);
    }
  };

  useEffect(() => {
    getNew(productId).then((data) => {
      console.log(data.new);
      formik.setValues({
        id: data.new.id,
        name: data.new.name,
        description: data.new.description,
        image: data.new.image_url,
        type_id: data.new.type_id,
        top_news: data.new.top_news ? "1" : "0",
        slug: data.new.slug,
        subtitle: data.new.subtitle,
        category_id: data.new.category_id,
        badges: data.new.badges_news[0].id,
        tags: data.new.tags.map(tag => ({ id: tag.id, name: tag.name })),
        meta_description: data.new.meta_description
      });
      setSelectedImage(data.new.image_url);
      setIsLoading(false);
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [productId]);
  const formik = useFormik({
    initialValues: {
      name: "",
      description: "",
      image: undefined,
      type_id: '',
      top_news: "0",
      slug: '',
      subtitle: "",
      badges: undefined,
      category_id: undefined,
      tags: [],
      meta_description: ''
    },
    validationSchema: UpdateProductSchema,
    onSubmit: async (values) => {
      // Se o valor de image não é um arquivo, ou seja, o usuário deseja remover a imagem existente
      if (!(values.image instanceof File)) {
        // A imagem é undefined ou o usuário deseja removê-la
        delete values.image;
        values.removeImage = true;  // Adicionamos uma flag para indicar ao backend que a imagem deve ser removida
      }

      setSubmitting(true);
      console.log(values);

      // Preparando dados para enviar ao backend
      const formData = UpdateProductData(values);

      const updated = await updateNew(formData);
      setMessage({
        error: false,
        content: "Produto atualizado com sucesso",
      });
      setSubmitting(false);
      onSubmit?.();
      setStatus(updated ? "success" : "error");
    },

  });
  if (isLoading) {
    return <LoadingIndicator />;
  }
  const typeOptions = types.map(type => ({ value: type.id, label: type.name }));
  const categoryOptions = categories.map(category => ({ value: category.id, label: category.name }));
  const handleTitleChange = (e) => {
    const newTitle = e.target.value;
    formik.setFieldValue('name', newTitle);
    // Gerar slug automaticamente a partir do título, mas somente se o slug ainda não foi manualmente editado pelo usuário
    if (!formik.touched.slug) {
      const newSlug = newTitle.toLowerCase().replace(/[\s]+/g, '-').replace(/[^\w-]+/g, '');
      formik.setFieldValue('slug', newSlug);
    }
  };

  const handleAddTag = async () => {
    const tagTrimmed = tagInput.trim();
    if (tagTrimmed) {
      const result = await addTags({ name: tagTrimmed });
      if (result.success) {
        const newTag = result.tag;  // Supõe que a API retorna o objeto tag completo
        const newTags = [...formik.values.tags, newTag];  // Adiciona a nova tag ao array
        formik.setFieldValue('tags', newTags);
        setTagInput('');
      } else {
        console.error('Erro ao adicionar tag');
      }
    }
  };


  const handleRemoveTag = async (tagToRemove) => {
    const result = await deleteTags(tagToRemove);
    if (result.success) {
      const newTags = formik.values.tags.filter(tag => tag.id !== tagToRemove.id);
      formik.setFieldValue('tags', newTags);
    } else {
      console.error('Erro ao remover a tag:', result.error);
    }
  };

  return (
    <Container className="mt-4">
      <Form onSubmit={formik.handleSubmit}>
        <Row>
          <Col sm={4}>
            <Form.Group className="mb-4">
              <Form.Label>Tipo de publicação*</Form.Label>
              <Select
                options={typeOptions}
                name="type_id"
                value={typeOptions.find(option => option.value === formik.values.type_id)}
                onChange={option => formik.setFieldValue('type_id', option.value)}
                placeholder="Selecione o tipo"
                noOptionsMessage={() => "Nenhuma opção disponível"}
                classNamePrefix="select"
              />
            </Form.Group>
          </Col>
          <Col sm={4}>
            <Form.Group className="mb-4">
              <Form.Label>Categoria*</Form.Label>
              <Select
                options={categoryOptions}
                name="category_id"
                value={categoryOptions.find(option => option.value === formik.values.category_id)}
                onChange={option => formik.setFieldValue('category_id', option.value)}
                placeholder="Selecione a categoria"
                noOptionsMessage={() => "Nenhuma opção disponível"}
                classNamePrefix="select"
              />
            </Form.Group>
          </Col>
          <Col sm={4}>
            <Form.Group className="mb-4">
              <Form.Label>Slug (URL)*</Form.Label>
              <InputGroup>
                <InputGroup.Append>
                  <InputGroup.Text><MdLink /></InputGroup.Text>
                </InputGroup.Append>
                <FormControl
                  type="text"
                  name="slug"
                  onChange={formik.handleChange}
                  value={formik.values.slug}
                  placeholder="URL automática ou manual"
                />
              </InputGroup>
            </Form.Group>
          </Col>
          <Col sm={4}
          >
          </Col>
        </Row>
        <Row>
          <Col sm={8}>
            <Form.Group className="mb-4">
              <Form.Label>Título*</Form.Label>
              <Form.Control type="text" name="name" onChange={handleTitleChange} value={formik.values.name} />
              <Form.Label>Subtítulo *</Form.Label>
              <Form.Control
                className="my-1"
                as="textarea"
                rows={3}
                name="subtitle"
                placeholder="Subtítulo da noticia"
                onChange={formik.handleChange}
                value={formik.values.subtitle}
                isValid={formik.touched.subtitle && !formik.errors.subtitle}
                isInvalid={formik.errors.subtitle}
              />
              <Form.Control.Feedback type="invalid">
                {formik.errors.subtitle}
              </Form.Control.Feedback>
            </Form.Group>

            <Form.Group className="mb-4">
              <Form.Label>Conteúdo*</Form.Label>
              <Editor
                apiKey="htwonga7qqiz96jdlavjriv28pllfct0g3qg18kbyml6xxos"
                tinymceScriptSrc={tinymceScriptSrc}
                initialValue={formik.values.description || ''}
                value={formik.values.description}
                init={{
                  height: 500,
                  menubar: true,
                  language: 'pt_BR',
                  language_url: 'https://cdn.tiny.cloud/1/htwonga7qqiz96jdlavjriv28pllfct0g3qg18kbyml6xxos/tinymce/6/langs/pt_BR.js',
                  plugins: [
                    'advlist', 'autolink', 'lists', 'link', 'image', 'charmap', 'preview', 'anchor',
                    'searchreplace', 'visualblocks', 'code', 'fullscreen', 'insertdatetime', 'media',
                    'mediaembed', 'table', 'help', 'wordcount'
                  ],
                  toolbar:
                    'undo redo | formatselect | bold italic backcolor | ' +
                    'alignleft aligncenter alignright alignjustify | ' +
                    'bullist numlist outdent indent | removeformat | image media mediaembed table',
                  automatic_uploads: true,
                  images_upload_handler: (blobInfo) => {
                    return new Promise((resolve, reject) => {
                      const reader = new FileReader();

                      reader.onloadend = () => {
                        const base64 = reader.result;
                        if (typeof base64 === 'string' && base64.startsWith('data:image')) {
                          resolve(base64); // 👈 AGORA SIM: Retorna apenas a string base64
                        } else {
                          reject('Formato de imagem inválido');
                        }
                      };

                      reader.onerror = () => {
                        reject('Erro ao ler o arquivo');
                      };

                      reader.readAsDataURL(blobInfo.blob());
                    });
                  }


                  ,


                  content_style: 'body { font-family:Helvetica,Arial,sans-serif; font-size:14px }'
                }}
                onEditorChange={(value) => formik.setFieldValue('description', value)}
              />

              {/*<ReactQuill
                theme="snow"
                value={formik.values.description}
                onChange={(value) => formik.setFieldValue('description', value)}
                style={{ height: '350px', width: '100%' }}
                modules={{
                  toolbar: [
                    [{ 'header': [1, 2, 3, false] }],
                    ['bold', 'italic', 'underline', 'strike'],
                    [{ 'list': 'ordered' }, { 'list': 'bullet' }, { 'indent': '-1' }, { 'indent': '+1' }],
                    ['link', 'image'],
                    ['clean']
                  ]
                }}
              />*/}
            </Form.Group>
          </Col>
          <Col sm={4}>
            <Form.Group className="mb-4">
              <Form.Label>Imagem destaque*</Form.Label>
              <div
                className="image-container"
                style={{
                  border: '2px dashed #ccc',
                  width: '192px',
                  height: '108px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  cursor: 'pointer',
                  position: 'relative'
                }}
                onClick={() => document.getElementById('fileInput').click()} // Aciona o input ao clicar na imagem
              >
                {selectedImage ? (
                  <Image src={selectedImage} thumbnail style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                ) : (
                  <span>Escolher imagem<br />1920x1080</span>
                )}
                <div
                  style={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    width: '100%',
                    height: '100%',
                    backgroundColor: 'rgba(0, 0, 0, 0.5)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    color: '#fff',
                    fontSize: '24px',
                    fontWeight: 'bold',
                    visibility: selectedImage ? 'visible' : 'hidden'
                  }}
                >
                  Alterar
                </div>
              </div>
              <Form.Control
                type="file"
                name="image"
                id="fileInput"
                style={{ display: 'none' }}
                onChange={(event) => {
                  setSelectedImage(URL.createObjectURL(event.currentTarget.files[0])); // Atualiza a visualização da imagem
                  formik.setFieldValue('image', event.currentTarget.files[0]); // Atualiza o valor no Formik
                }}
              />
            </Form.Group>
            <Form.Group className="mb-4">
              <Form.Label>Emblemas</Form.Label>
              {badges.map((badgeItem) => (
                <Form.Check
                  key={badgeItem.id}
                  type="radio"
                  label={badgeItem.name}
                  name="badges"
                  value={badgeItem.id}
                  onChange={(e) => formik.setFieldValue('badges', parseInt(e.target.value))}
                  checked={formik.values.badges === badgeItem.id}
                />
              ))}
            </Form.Group>
            <Form.Group controlId="formTags" className="mb-4">
              <Form.Label>Tags</Form.Label>
              <InputGroup>
                <FormControl
                  type="text"
                  placeholder="Adicione tags"
                  value={tagInput}
                  onChange={e => setTagInput(e.target.value)}
                  onKeyPress={event => {
                    if (event.key === 'Enter' && !submitting) {
                      event.preventDefault();
                      handleAddTag();
                    }
                  }}
                />
                <InputGroup.Append>
                  <InputGroup.Text onClick={handleAddTag} ><MdAdd /></InputGroup.Text>
                </InputGroup.Append>
              </InputGroup>
              <div>
                {formik.values.tags.map((tag, index) => (
                  <Badge key={tag.id} pill className="mr-2">
                    {tag.name}
                    <MdRemoveCircle onClick={() => handleRemoveTag(tag)} style={{ cursor: 'pointer', marginLeft: '10px' }} />
                  </Badge>
                ))}

              </div>

            </Form.Group>


            <Form.Group controlId="formMetaDescription" className="mb-4">
              <Form.Label>Preview do Google</Form.Label>
              <FormControl
                as="textarea"
                rows="3"
                placeholder="Insira uma metadescrição relacionada ao conteúdo."
                value={formik.values.meta_description}
                onChange={e => formik.setFieldValue('meta_description', e.target.value)}
              />
              <Form.Text className="text-muted">
                Se o campo ficar em branco, o Google tentará encontrar uma parte relevante do conteúdo para mostrar nos resultados da pesquisa.
              </Form.Text>
            </Form.Group>
          </Col>
        </Row>
        {status === "success" && (
          <SuccessAlert msg="Produto atualizado" onClose={clearStatus} />
        )}

        {status === "error" && (
          <ErrorAlert msg="Um erro ocorreu." onClose={clearStatus} />
        )}
        <Form.Check
          className="my-1"
          type="checkbox"
          name="top_news"
          label="Colocar Noticias em Destaque?"
          onChange={(e) => formik.setFieldValue("top_news", e.target.checked ? "1" : "0")}
          checked={formik.values.top_news === "1"}
        />
        <Button type="submit" disabled={submitting} className="mb-4">Atualizar Publicação</Button>
      </Form>
    </Container>
  );
}
